/**
 * An AMD wrapper around polyglot.js for loaders (like DOJO) that don't
 * support shims
 */

define(['text!/bower_components/polyglot/build/polyglot.min.js'], function(script){
	(new Function(script))();
	// eslint-disable-next-line no-undef
	return Polyglot;
});

